module.exports = __webpack_public_path__ + "img/Public Bank.32babaf3.png";